<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;">
			<div>
				<el-tabs  >				
					<el-tab-pane  label="电能表" ></el-tab-pane>
			    </el-tabs>
			</div>
		</el-col>
		<el-col :span="24" class="toolbar" style="padding: 0px;padding-bottom:8px;margin: 5px 0px;">
			<el-button v-if="permissionNodeList.NYBGL_add.hasEntitle == 1" @click="handleAdd">新增能源表</el-button>
			<el-button v-if="permissionNodeList.NYBGL_del.hasEntitle == 1" @click="handleBatchDelete">删除能源表</el-button>
			<el-button v-if="permissionNodeList.NYBGL_import.hasEntitle == 1" @click="handleBatchImport">批量导入</el-button>
			<el-button v-if="permissionNodeList.NYBGL_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
			<div style="float: right;" >
			<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 130px;box-sizing: border-box;">项目归属:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">电能表搜索:</label>
				<el-input style="width: 180px;" placeholder="输入名称或编号" v-model="filterForm.search_word">
				</el-input>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
			</div>
		</el-col>
		<el-dialog title="批量导入项目" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column  type="selection" width="80">
			</el-table-column>
			<el-table-column prop="energyType" label="能源表类型" width="180" sortable>
			</el-table-column>
			<el-table-column prop="houseNumber" label="能源表对应户号" width="180"  sortable>
			</el-table-column>
			<el-table-column prop="address" label="能源表地址" width="200" sortable>
			</el-table-column>
			<el-table-column prop="name" label="能源表名称" width="200" sortable>
			</el-table-column>
			<el-table-column prop="sn"  label="传感器编号" width="160" sortable>
			</el-table-column>
			<el-table-column label="操作" width="180">
				<template scope="scope">
					<el-button size="small" v-if="permissionNodeList.NYBGL_edit.hasEntitle == 1" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增界面-->
		<el-dialog title="新增能源表" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="saveFormRules" ref="addForm">
				<el-form-item  label="能源表类型"  >
					<el-select disabled style="width: 400px"> 
						<el-option  label="电能表" ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="houseNumber" label="对应户号">
					<el-input v-model="addForm.houseNumber" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="name" label="电能表名称">
					<el-input v-model="addForm.name" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="addForm.sn" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="电能表地址" >
					<el-input v-model="addForm.address" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="addForm.projectId"  filterable placeholder="请选择" style="width: 400px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="addForm.deviceModel" style="width: 400px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="addForm.deviceModel =='D485ZT'" prop="paramLenth"  label="电能值长度" >
					<el-input v-model="addForm.paramLenth" auto-complete="off" style="width: 150px"></el-input>
					<label  style="width: 30px;text-align: left;">字节</label>
				</el-form-item>
				<el-form-item  v-if="addForm.deviceModel =='D485ZT'" label="解析方式" style="padding-bottom:30px;">
					<el-select  v-model="addForm.paramUnit" placeholder="请选择单位" style="width:150px;">
						<el-option  label="1" value="1"></el-option>
						<el-option  label="0.1" value="0.1"></el-option>
						<el-option  label="0.01" value="0.01"></el-option>
				    </el-select>
					<el-select v-if="addForm.deviceModel =='D485ZT'" v-model="addForm.paramType" placeholder="请选择参数类型" style="width:150px;padding-left:15px;">
						<el-option  label="Float" value="Float"></el-option>
						<el-option  label="INT32" value="INT32"></el-option>
						<el-option  label="INT16" value="INT16"></el-option>
						<el-option  label="UINT32" value="UINT32"></el-option>
						<el-option  label="UINT16" value="UINT16"></el-option>
				    </el-select>
				</el-form-item>		
				<el-form-item v-if="addForm.deviceModel =='D485ZT'" label="选择大端/小端" prop="modeType">
					<el-radio v-model="addForm.modeType" class="radio" label="0">大端模式</el-radio>
					<el-radio  v-model="addForm.modeType" class="radio" label="1">小端模式</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="能源表" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="saveFormRules" ref="editForm">
				<el-form-item  label="能源表类型"  >
					<el-select disabled style="width: 400px"> 
						<el-option  label="电能表" ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="houseNumber" label="对应户号">
					<el-input v-model="editForm.houseNumber" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="name" label="电能表名称">
					<el-input v-model="editForm.name" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="sn" label="传感器编号">
					<el-input v-model="editForm.sn" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="电能表地址" >
					<el-input v-model="editForm.address" auto-complete="off" style="width: 400px"></el-input>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="editForm.projectId"  filterable placeholder="请选择" style="width: 400px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="传感器类型"  prop="deviceModel">
					<el-select   v-model="editForm.deviceModel" style="width: 400px"> 
						<el-option v-for="(item,index) in deviceModelList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.deviceModel =='D485ZT'" prop="paramLenth"  label="电能值长度" >
					<el-input v-model="editForm.paramLenth" auto-complete="off" style="width: 150px"></el-input>
					<label  style="width: 30px;text-align: left;">字节</label>
				</el-form-item>
				<el-form-item  v-if="editForm.deviceModel =='D485ZT'" label="解析方式" style="padding-bottom:30px;">
					<el-select  v-model="editForm.paramUnit" placeholder="请选择单位" style="width:150px;">
						<el-option  label="1" value="1"></el-option>
						<el-option  label="0.1" value="0.1"></el-option>
						<el-option  label="0.01" value="0.01"></el-option>
				    </el-select>
					<el-select v-if="editForm.deviceModel =='D485ZT'" v-model="editForm.paramType" placeholder="请选择参数类型" style="width:150px;padding-left:15px;">
						<el-option  label="Float" value="Float"></el-option>
						<el-option  label="INT32" value="INT32"></el-option>
						<el-option  label="INT16" value="INT16"></el-option>
						<el-option  label="UINT32" value="UINT32"></el-option>
						<el-option  label="UINT16" value="UINT16"></el-option>
				    </el-select>
				</el-form-item>		
				<el-form-item v-if="editForm.deviceModel =='D485ZT'" label="选择大端/小端" prop="modeType">
				    <el-radio v-model="editForm.modeType" class="radio" label="0">大端模式</el-radio>
					<el-radio  v-model="editForm.modeType" class="radio" label="1">小端模式</el-radio>
					<!-- <el-radio-group  v-model="editForm.modelType">
						<el-radio  class="radio" :label="0">大端模式</el-radio>
						<el-radio   class="radio" :label="1">小端模式</el-radio>
					</el-radio-group> -->
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				deviceModelList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					name: [
						{ required: true, message: '名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					sn: [
						{ required: true, message: '编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					address: [
						{ required: true, message: '地址不能为空', trigger: 'blur' },
					],
					houseNumber: [
						{ required: true, message: '户号不能为空', trigger: 'blur' },
					],
					deviceModel:[
						{ required: true, message: '请选择传感器类型'},
					],
					// paramLenth:[
					// 	{ required: true, message: '请输入电能值长度'},
					// 	// { type: 'number', message: '电能值长度必须为数字值', trigger: 'blur' },
					// ],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					modeType:[
					    { required: true, message: '请选择大端或小端'},
					],
				},
				addForm: {
					modeType:'0'
				},
				editForm: {
				},
				filterForm: {
					
				},
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/meterRead/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				filterDeviceModel:'',
				filterSysCode:'',
				projectList:[],
			}
		},
		methods: {
			checkinlist(){
				 console.log(this.editForm.sysIdJoinCodes);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.meterRead_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					if(!tools.strIsEmpty(res.data.list))
					 for (let index = 0; index < res.data.list.length; index++) {
						 res.data.list[index].energyType = "电能表"
					}
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleEdit: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.meterRead_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.editForm = Object.assign({}, res.data);
						if(this.editForm.modeType){
							this.editForm.modeType = this.editForm.modeType.toString()
						}
						this.editForm.projectId  = String(this.editForm.projectId);
						this.editFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该抄表终端详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				this.get_list_data();
			},
			handleAdd: function () {
				let param = {};
				this.addFormVisible = true;
				this.addForm = {
					paramLenth:4
				};	
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						if(this.addForm.deviceModel =='D485ZT'){
							if(isNaN(parseInt(this.addForm.paramLenth))){
							tools.error(new Vue(),"电能值长度请输入数字");
							return;
							}
							if(parseInt(this.addForm.paramLenth) ==NaN || (parseInt(this.addForm.paramLenth)<1) || (parseInt(this.addForm.paramLenth)>8)){
								tools.error(new Vue(),"电能值长度只能为1-8的自然数");
								return;
							}
							if(tools.strIsEmpty(this.addForm.paramUnit) || tools.strIsEmpty(this.addForm.paramType)){
								tools.error(new Vue(),"解析方式的单位或参数类型选择为空");
								return;
							}
						}
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.meterRead_saveOrUpdate_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						if(this.editForm.deviceModel =='D485ZT'){
							if(isNaN(parseInt(this.editForm.paramLenth))){
							tools.error(new Vue(),"电能值长度请输入数字");
							return;
							}
							if(parseInt(this.editForm.paramLenth) ==NaN || (parseInt(this.editForm.paramLenth)<1) || (parseInt(this.editForm.paramLenth)>8)){
								tools.error(new Vue(),"电能值长度只能为1-8的自然数");
								return;
							}
							if(tools.strIsEmpty(this.editForm.paramUnit) || tools.strIsEmpty(this.editForm.paramType)){
								tools.error(new Vue(),"解析方式的单位或参数类型选择为空");
								return;
							}
						}
						this.editSubmitButtonDisabled=true;
						let param = Object.assign({}, this.editForm);
						param.projectId = parseFloat(param.projectId);
						this.listLoading = true;
						let self = this;
						api.meterRead_saveOrUpdate_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			getDeviceModelList: function () {
				let param = {dataType:''};
				api.meterRead_getMeterReadModelList_request(param).then((res) => {
					if(res.data){
						this.deviceModelList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseFloat(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			handleBatchDelete:function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择要删除的数据");
					return
				}
				this.$confirm('确认删除吗?', '提示', {showClose:false}).then(() => {
				    let param = {ids:this.tableSelectionIds};
					api.meterRead_batchRemove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
			downloadTemplate(){
				let param = {};
				api.meterRead_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_energyMeterManageList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					keys:this.search_word,
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				this.listLoading = true;
				api.meterRead_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'meterReadManageList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
		},
		mounted() {
			this.get_list_data();
			this.getDeviceModelList();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// energy_meter_manage_list.vue?6269f6b1